export const config = {
  clientId: import.meta.env.VITE_CLIENT_ID,
  resourceId : import.meta.env.VITE_RESOURCE_ID
};